export { ListNode } from './ListsSpecs';
export var ListAction;
(function (ListAction) {
    ListAction["ToBulletList"] = "toBulletList";
    ListAction["ToOrderedList"] = "toOrderedList";
    ListAction["SinkListItem"] = "sinkListItem";
    ListAction["LiftListItem"] = "liftListItem";
})(ListAction || (ListAction = {}));
